import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';
import Fade from '@mui/material/Fade';
import AudioButton from './AudioButton';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';



// import { createStore } from 'redux';
// import { configureStore } from '@reduxjs/toolkit';

import MySvg from '../logo.svg';


function VocabCard(props) {
            const [highlight, setHighlight] = useState(false);
            const [flipped, setFlipped] = useState(false);

            function toggleHighlight() {
              setHighlight(!highlight);
            }

            useEffect(() => {
              setFlipped(false);
            }, [props.name])

            return (
              <Button variant={props.variant}  disableRipple
              onClick = {(e) => {
                  // console.log(e.target.tagName);
                  if (props.done === true) {
                    if (e.target.tagName !== "svg" && e.target.tagName !== "path" && !e.target.classList.contains('AudioButton')) {
                      setFlipped(!flipped)
                      return;
                    }
                  }
                  // console.log(e.target)
                  if (e.target.tagName !== "svg" && e.target.tagName !== "path" && !e.target.classList.contains('AudioButton')) {
                    props.onClick(props.name)
                    return;
                  }
                } 
              }
              // disabled={props.done === true && props.ans != props.name}
              sx={{textTransform : "none", display:{"xs": "block", "md":"block"}}}>
                  <div>
                  <Card sx={{ minWidth: 250, maxWidth: 250 }}>
                  <Fade in={props.showCards} timeout={{exit:200, enter:5000}}>
                    <CardMedia
                          sx={{display:{"xs": "none", "md":"block"}}}
                          component="img"
                          height="170"
                          src={`${props.imgbase64}`}
                          alt={props.alt}
                    />
                    </Fade>

                    <Fade in={props.showCards} timeout={{exit:200, enter:5000}}>

                    <CardMedia
                          sx={{display:{"xs": "block", "md":"none"}}}
                          component="img"
                          height="100"
                          width="50"
                          src={`${props.imgbase64}`}
                          alt={props.alt}
                    />
                     </Fade>
                    
                    <CardContent sx={{display:{"xs": "none", "md":"block"}}}>
                      <Typography  sx={{ fontSize: 25 }} color=
                      {flipped ? "text.secondary" : "text.primary"} gutterBottom>
                        {flipped ? props.def : props.name}
                      </Typography> 
                      <AudioButton audioUrl={props.audioUrl} class="AudioButton" />
                    </CardContent>

                    {/* <Fade in={props.showCards} timeout={{exit:200, enter:5000}}> */}
                    <Box sx={{mt:2, display:{"xs": "block", "md":"none"}}}>
                      
                        <Typography  sx={{ fontSize: 18,  lineHeight: 0}}
                        color="text.primary" gutterBottom>
                          {flipped ? props.def : props.name}
                        </Typography>
                        
                        <AudioButton audioUrl={props.audioUrl}/>
                    </Box>
                      {/* </Fade> */}
                  </Card>
                </div>
              </Button>
            );
          }

export default VocabCard;